import React from 'react'
import { NavLink } from 'react-router-dom'

import { Order } from '../redux/types'

const Persons: React.FC<{ order: Order }> = ({ order }) => {
  const defaultPicture = `${process.env.PUBLIC_URL}/img/default-user.png`

  return (
    <div className="row">
      <h2 className="margin-bottom-16"><i className="fa fa-users"/> Pessoas</h2>
      {/* Partner */}
      <NavLink className="col-4" to={`/panel/partner/${order.partner.id}`} target="__blank">
        <div className="row panel">
          <img
            alt="Partner"
            src={order.partner.pictureSmall}
            style={{ width: 60, height: 60, borderRadius: '50%' }}
          />

          <div className="grow padding-left-16">
            <h3>{ order.partner.name }</h3>
            <p>{ order.partner.category?.name }</p>
          </div>
        </div>
      </NavLink>

      {/* Client */}
      <div className="col-4 padding-lr-16">
        <div className="row panel">
          <img
            alt="Partner"
            src={order.user.person?.picture || defaultPicture}
            style={{ width: 60, height: 60, borderRadius: '50%' }}
          />

          <div className="grow padding-left-16">
            <h3>{ order.user.person?.name }</h3>
            <p>{ order.user.person?.phone || order.user.person?.email }</p>
          </div>
        </div>
      </div>

      {/* Deliverer */}
      <div className="col-4">
        <div className="row panel">
          <img
            alt="Partner"
            src={order.deliverer?.person?.picture || defaultPicture}
            style={{ width: 60, height: 60, borderRadius: '50%' }}
          />

          <div className="grow padding-left-16">
            <h3>{ order.deliverer?.person?.name || 'Sem Entregador' }</h3>
            <p>{ order.deliverer?.person?.phone || order.deliverer?.person?.email || '...' }</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Persons
